var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17.455,
    viewBox: "0 0 16 17.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "notifications-icon",
    d: "M-1367-2226.5a2,2,0,0,1-2-2h4A2,2,0,0,1-1367-2226.5Zm8-3h-16v-2l2-6a7.1,7.1,0,0,1,1.174-4.06,5.519,5.519,0,0,1,3.326-2.26,6.9,6.9,0,0,1,1.459-.135,7.949,7.949,0,0,1,1.542.135,5.525,5.525,0,0,1,3.323,2.264A7.087,7.087,0,0,1-1361-2237.5l2,6v2Zm-7.915-12.494a6.492,6.492,0,0,0-1.2.1c-2.06.488-3.149,2.007-3.149,4.395l-1.832,6.1h12.313l-1.982-5.976c0-2.434-1.108-4.038-3.119-4.515A4.307,4.307,0,0,0-1366.915-2241.994Z",
    transform: "translate(1375 2243.955)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.ce374330.svg";
export { ForwardRef as ReactComponent };